import { render, staticRenderFns } from "./IsSeasonalRentalQuestion.vue?vue&type=template&id=66b0865a&scoped=true"
import script from "./IsSeasonalRentalQuestion.vue?vue&type=script&lang=ts"
export * from "./IsSeasonalRentalQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b0865a",
  null
  
)

export default component.exports